<template>
    <div>
        <form @submit.prevent="submitInfo">
            <div class="form-group">
                <label class="form-label">{{$t('label.location')}}</label>
                <div class="input-group bg-white shadow-inset-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-transparent border-right-0">
                            <i class="fas fa-map-marker-alt"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.location')" v-model="infoLocation">
                </div>
            </div>
            <div class="form-group">
                <label class="form-label">{{$t('label.city')}}</label>
                <div class="input-group">
                    <div class="input-group-prepend w-100">
                        <label class="input-group-text border-right-0 bg-transparent">
                            <i class="fas fa-map-marker-alt"></i>
                        </label>
                        <multiselect  
                            v-model="selectedCity" 
                            :options="cities" 
                            group-values="city" group-label="state" 
                            track-by="cityID" label="city" 
                            :show-labels="false" 
                            openDirection="below" 
                            @select="selectCity">
                            <span slot="noResult">{{$t('table.no_records')}}</span>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label class="form-label">{{$t('label.contact')}}</label>
                <div class="input-group bg-white shadow-inset-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-transparent border-right-0">
                            <i class="fas fa-phone-alt"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.contact')" v-model="infoContact" @keyup="contactValidation">
                </div>
                <div id="err" class="error-validation"></div>
            </div>
            <div class="text-left mb-3">
                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
            </div>
        </form>
    </div>
</template>

<script>
import _ from 'lodash';
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import {contactValidation} from './../../../../assets/js/dashboard/utilities'
export default {
    name: 'general',
    props:{
        results: { type: Object }
    },
    data: function(){
        return{
            infoLocation: "", infoContact: "",
            cities: [], selectedCity: {},
        }
    },
    methods:{
        submitInfo(){
            var results = {};
            results["location"] = this.infoLocation
            results["cityID"] = this.selectedCity.cityID
            results["city"] = this.selectedCity.city
            results["contact"] = this.infoContact
            this.$emit('submitInfo', results);
        },
        contactValidation(){
            var err = contactValidation(this.infoContact);
            document.getElementById('err').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
        },
        async getCityList(){
            let $vm = this;
            const url =  $vm.$api.INFO + $vm.$api.CITY;

            var city = [];
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                city = response.data.result
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return city;
        },
        selectCity(item){
            this.selectedCity = item
        }
    },
    async mounted(){
        let $vm = this;
        $vm.infoLocation = $vm.results.location
        $vm.infoContact = $vm.results.contact

        var city = await $vm.getCityList();
        var group = _.groupBy(city, 'stateID');
        for(var id in group){
            var data = {}
            data["state"] = group[id][0].state
            var cityArr = []
            for(var i=0; i<group[id].length; i++){
                cityArr.push({
                    cityID: group[id][i].cityID,
                    city: group[id][i].city,
                })
            }
            data["city"] = cityArr;
            $vm.cities.push(data)
        }
        $vm.selectedCity = {cityID: parseInt($vm.results.cityID), city: $vm.results.city}
    }
}
</script>
<style scoped>
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>